import { Button } from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Divider } from '@mybridge/ui/divider';
import { HStack, Stack } from '@mybridge/ui/layout';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import { SlideFade } from '@mybridge/ui/transitions';
import { triggerFetchPosts } from 'packages/mybridgev4/store/actions/post.actions';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PostFormBody } from 'v4/components/post-form/body';
import {
  PostFormContext,
  usePostFormContext,
} from 'v4/components/post-form/context';
import { PostFormFooter } from 'v4/components/post-form/footer';
import { PostFormHeader } from 'v4/components/post-form/header';
import { PostBoxBody } from 'v4/components/post/body';
import { PostBoxContext, usePostBoxContext } from 'v4/components/post/context';
import { PostBoxHeader } from 'v4/components/post/header';

export const PostBoxQuotePostModal = ({ ...props }) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { post, refetch, quotePostModal,multiPost } = useContext(PostBoxContext);
  const { currentProfile: selectedPostingProfile } = useSelector(
    (state) => state.userProfile
  );
  const { content, repost } = post;

  // useEffect(() => {
  //   console.log("Test eerer", multiPost)
  // },[multiPost])

  const refetchAll = () => {
    refetch();
    dispatch(triggerFetchPosts(true));
    quotePostModal?.onClose?.();
  };

  const postFormContext = usePostFormContext({
    post,
    refetchAll,
  });

  useEffect(() => {
    setTimeout(() => {
      postFormContext?.setText?.('');
    }, 10);

  }, []);

  const { formContainerRef, expanded } = postFormContext ?? {};
  return (
    <PostFormContext.Provider value={{ ...(postFormContext ?? {}) }}>
      <Modal size="2xl" {...props}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#3D5A80"
              fontSize="20px"
              textAlign="center"
              fontWeight="400">
            <Text>{t('post.quotePost') || "Quote Post"}</Text>
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody>
            <Stack ref={formContainerRef} transition="all 0.2s">
              <Stack w="100%">
                <PostFormHeader fromQuote={true} multiPost={multiPost} />
                <PostFormBody showMedia={true} />
                <Stack
                  spacing={0}
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius={5}
                  pb={2}
                >
                  <PostBoxHeader actionMenuEnabled={false} fromQuote={true}/>
                  <PostBoxBody />
                </Stack>
              </Stack>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                borderRadius="full"
                variant="secondary"
                onClick={(e) => quotePostModal?.onClose?.()}
              >
                {t('buttons.cancel')||"Cancel"}
              </Button>
              <Button
                borderRadius="full"
                isLoading={postFormContext?.quotePostLoading}
                onClick={(e) => postFormContext?.quotePost?.(selectedPostingProfile)}
                variant="primary"
                isDisabled={
                  postFormContext?.text?.length <= 0 ||
                  postFormContext?.text?.length > postFormContext?.textMaxLength
                }
              >
                {t('post.repost') || "Repost"}
              </Button>
            </HStack>
          </ModalFooter>
          {/* <Stack style={{padding:"12px 16px 12px 16px"}}>
            <PostFormFooter />
          </Stack> */}
        </ModalContent>
      </Modal>
    </PostFormContext.Provider>
  );
};
